import CommonPropertiesWithGeometry from "./commonPropertiesWithGeometry";
class NodeSourceAdditionalInfo extends CommonPropertiesWithGeometry {
    constructor(DocumentObject, Created, Description, Color, NodeWidth, NodeHeight, InputLinksCount, OutputLinksCount) {
        super(Created, Description, Color, NodeWidth, NodeHeight);
        this.DocumentObject = DocumentObject;
        this.InputLinksCount = InputLinksCount;
        this.OutputLinksCount = OutputLinksCount;
    }
}
export default NodeSourceAdditionalInfo;
